import React from 'react';
import { MediaTab, MediaSectionId } from '../wizard/MediaTab';

interface GettyStepProps {
  catalogItemId?: string;
  ownerId?: string | null;
}

const GETTY_SECTIONS: ReadonlySet<MediaSectionId> = new Set<MediaSectionId>([
  'media-work-type',
  'media-techniques',
  'media-materials',
  'media-substrate',
  'media-additional-comments',
]);

/**
 * Renders the Getty AAT pickers (work type, techniques, materials,
 * substrate) plus the free-text Additional Comments field. The plain
 * "Media description" lives on DescribeStep; Additional Comments was
 * moved here so all media-related vocabulary edits sit together.
 */
export const GettyStep: React.FC<GettyStepProps> = ({ catalogItemId, ownerId }) => (
  <MediaTab
    catalogItemId={catalogItemId}
    ownerId={ownerId}
    visibleSections={GETTY_SECTIONS}
    hideMultiplesInWorkType
  />
);
